exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reports-frame-style[data-v-f3c059b0] {\n  height: 100vh;\n  width: 100%;\n  border: 1px solid grey;\n  border-radius: 7px;\n}\n.one-page table[data-v-f3c059b0] {\n  border-collapse: collapse;\n  margin: 0;\n  width: 100%;\n  table-layout: fixed;\n  word-break: break-word;\n}\n.one-page table[data-v-f3c059b0],\n.one-page th[data-v-f3c059b0],\n.one-page td[data-v-f3c059b0] {\n  border: 1px solid #b9b9b9;\n  padding: 2px 5px;\n}\n.one-page th[data-v-f3c059b0] {\n  text-align: center !important;\n  background-color: #f0f0f0;\n}\n", ""]);

// exports
